/**
 * KYRDROS API client — KS-PF1
 * - Cookies (HttpOnly ky_session) handle authentication automatically via withCredentials.
 * - CSRF token is stored in the session module and injected into state-changing requests.
 * - X-Tenant-ID header REMOVED: tenant is resolved server-side from the authenticated session.
 * - On 401: clear session and redirect to /login.
 */
import axios from 'axios';
import { session } from '@/lib/session';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Inject CSRF token on state-changing requests
api.interceptors.request.use((config) => {
  const method = (config.method ?? '').toLowerCase();
  if (['post', 'put', 'delete', 'patch'].includes(method)) {
    const csrf = session.getCsrfToken();
    if (csrf) {
      config.headers = config.headers ?? {};
      config.headers['X-CSRF-Token'] = csrf;
    }
  }
  return config;
});

// Redirect to /login on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      session.clearAll();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
